import { React, Fragment, memo, useContext } from 'react'
import { Col, Row, Icon, Checkbox, BodyText } from '@paypalcorp/pp-react'

import { string, func } from 'prop-types'

import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'

const DARInfo = memo((props) => {
  const { title, icon, value, onSectionClick, selectedInfos, domid } = props
  const worldReady = useContext(WorldReadyContext)
  return (
    <Fragment>
      <Row className="requestForm-row" id={domid}>
        <Col xs={2} md={1}>
          <Icon name={icon} />
        </Col>
        <Col className="requestForm-info-title">
          <BodyText>
            <Message id={title} />
          </BodyText>
        </Col>
        <Col xs={2} md={1}>
          <Checkbox
            id={`chk-${domid}`}
            theme="v2"
            name="infooption"
            aria-label={new MessageFormat(worldReady, { id: title }).format()}
            value={value}
            checked={selectedInfos && selectedInfos.includes(value)}
            onChange={onSectionClick}
          />
        </Col>
      </Row>
    </Fragment>
  )
})

DARInfo.propTypes = {
  title: string,
  icon: string,
  value: string,
  onSectionClick: func.isRequired,
}
DARInfo.displayName = 'DARInfo'

export default DARInfo
